module.exports = __webpack_public_path__ + "static/img/hangye_pic.66188e88.png";